<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>
<div class="pkg_status_wrap row float-right">
  <div class="col-md-7 part_current_status text-right">{{'PACKAGEID' | translate}}:
    <span class="status_review">{{routePackageID}}</span>
  </div>
  <div class="col-md-5 part_current_status">{{'STATUS' | translate}}:
    <span class="status_review" [ngClass]="{rejected:'red_alert',rejectedAndClosed:'red_alert'}[overAllPackageIDStatus]">{{displayOverallStatus}}</span>
  </div>
</div>
<form [formGroup]="partInfoForm" #f="ngForm" novalidate>
  <!-- <p>Is "partInfoForm" valid? {{partInfoForm.valid}}</p> -->
  <section class="global_part_info pad-top-40 no-mar-lr pad-btm-20 pad-lr-15">
    <div class="row">
      <div class="col-md-3">
        <div class="form-group row">
          <label for="" class="col-sm-4 col-form-label">{{'PARTNUMBER' | translate}}
            <span class="required">*</span>
          </label>
          <div class="col-sm-8">
            <input type="text" class="form-control" formControlName="partNumber">
          </div>
        </div>
        <div class="form-group row">
          <label for="" class="col-sm-4 col-form-label">{{'PARTNAME' | translate}}
            <span class="required">*</span>
          </label>
          <div class="col-sm-8">
            <input type="text" class="form-control" formControlName="partName">
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group row" [ngClass]="{'has-error': partInfoForm.get('partWeight').invalid && f.submitted}">
          <label for="" class="col-sm-6 col-form-label">{{'PARTWEIGHT' | translate}}
            <span class="required">*</span>
          </label>
          <div class="col-sm-6">
            <input type="text" class="form-control" formControlName="partWeight">
            <errors [control]="partInfoForm.controls.partWeight"></errors>
            <div *ngIf="f.submitted && partInfoForm.get('partWeight').invalid " class="required-error">
              {{'FieldRequired' | translate}}
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label for="delPlantName" class="col-sm-6 col-form-label">{{'PARTMATERIAL' | translate}}</label>
          <div class="col-sm-6">
            <input type="text" class="form-control" formControlName="partMaterial">
            <errors [control]="partInfoForm.controls.partMaterial"></errors>
            <small *ngIf="partInfoForm.get('partMaterial').invalid && f.submitted" class="required-error">
              {{'FieldRequired' | translate}}
            </small>
          </div>
        </div>
      </div>

      <div class="col-md-2">
        <div class="form-group row" [ngClass]="{'has-error': partInfoForm.get('partClassification').invalid && f.submitted}">
          <label for="" class="col-sm-6 col-form-label">{{'PARTCLASSIFICATION' | translate}}
            <span class="required">*</span>
          </label>
          <div class="col-sm-6">
            <select class="form-control" formControlName="partClassification">
              <option value="" selected>Select</option>
              <option *ngFor="let opt of partClassificationOpt" [value]="opt">{{opt}}</option>
            </select>
            <errors [control]="partInfoForm.controls.partClassification"></errors>
            <div *ngIf="partInfoForm.get('partClassification').invalid && f.submitted" class="required-error">
              {{'FieldRequired' | translate}}
            </div>
          </div>
        </div>
        <!-- <div class="form-group row">
          <label for="" class="col-sm-7 col-form-label">Series Part</label>
          <div class="col-sm-5">
              <select class="form-control" formControlName="seriesPart">
                  <option value="">Select</option>
                  <option *ngFor="let opt of seriesPartOpt" [value]="opt">{{opt}}</option>
                </select>
          </div>
        </div> -->
        <div class="form-group row" [ngClass]="{'has-error': partInfoForm.get('ProductionStatus').invalid && f.submitted}">
          <label for="" class="col-sm-6 col-form-label">{{'PRODUCTIONSTATUS' | translate}}
            <span class="required">*</span>
          </label>
          <div class="col-sm-6">
            <select class="form-control" formControlName="ProductionStatus">
              <option value="">{{'Select' | translate}}</option>
              <option *ngFor="let opt of seriesPartOpt" [value]="opt">{{opt}}</option>
            </select>
            <errors [control]="partInfoForm.controls.ProductionStatus"></errors>
            <div *ngIf="partInfoForm.get('ProductionStatus').invalid && f.submitted" class="required-error">
              {{'FieldRequired' | translate}}
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-2">
        <!-- <div class="row">
          <label for="partNumber" class="col-sm-6 col-form-label">Change Over Date</label>
          <div class="col-sm-6">
            <div class="form-group">
              <div class="input-group">
                <input class="form-control" placeholder="yyyy-mm-dd" name="d3" ngbDatepicker #d3="ngbDatepicker" formControlName="changeDate">
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary dpCalbtn" (click)="d3.toggle()" type="button">
                    <img src="../../../assets/calendar-icon.svg" style="width: 1.2rem; height: 1rem; cursor: pointer;" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="form-group row">
          <label for="" class="col-sm-6 col-form-label">{{'PREVPARTNUMBER' | translate}}</label>
          <div class="col-sm-6">
            <input type="text" class="form-control" formControlName="predecessorNumber">
            <span class="lookup_text" (click)="openLookup(lookupModal)" *ngIf="(overAllPackageIDStatus == 'new' || overAllPackageIDStatus == 'inProgress' ) && userRoleId != '15'">{{'LOOKUP'
              | translate}}</span>
            <errors [control]="partInfoForm.controls.predecessorNumber"></errors>
          </div>

        </div>
        <div class="form-group row">
          <label for="" class="col-sm-6 col-form-label">{{'VSCODE' | translate}}</label>
          <div class="col-sm-6">
            <input type="text" class="form-control" formControlName="vsCode">
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group row" [ngClass]="{'has-error': (partInfoForm.get('vsLastName').touched || 
        partInfoForm.get('vsLastName').dirty) 
        && partInfoForm.get('vsLastName').invalid }">
          <label for="" class="col-sm-7 col-form-label">{{'VSLASTNAME' | translate}}</label>
          <div class="col-sm-5">
            <input type="text" class="form-control" formControlName="vsLastName">
            <errors [control]="partInfoForm.controls.vsLastName"></errors>
          </div>
        </div>
        <div class="form-group row" [ngClass]="{'has-error': (partInfoForm.get('vsFirstName').touched || 
        partInfoForm.get('vsFirstName').dirty) 
        && partInfoForm.get('vsFirstName').invalid }">
          <label for="vsFirstName" class="col-sm-7 col-form-label">{{'VSFIRSTNAME' | translate}}</label>
          <div class="col-sm-5">
            <input type="text" class="form-control" formControlName="vsFirstName">
            <errors [control]="partInfoForm.controls.vsLastName"></errors>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="legend_info float-right">* {{'Vendor Scheduler' | translate}}</div>
  <section class="pad-lr-30 top_dash_brd mar-top-50">
    <div class="row">
      <div class="col-md-2 pad-top-40">
        <div class="pad-btm-20 dta_title">{{'DIMENSIONS' | translate}}</div>
        <div class="form-group no-mar-btm row pad-btm-10" [ngClass]="{'has-error':  partInfoForm.get('dimensionWidth').invalid && f.submitted}">
          <div class="col-md-6">
            {{'W' | translate}}
            <span class="required">*</span>
          </div>
          <div class="col-md-6">
            <input type="text" class="form-control dimension_input" formControlName="dimensionWidth">
          </div>
          <errors [control]="partInfoForm.controls.dimensionWidth"></errors>
          <div *ngIf="partInfoForm.get('dimensionWidth').invalid && f.submitted" class="required-error">
            {{'FieldRequired' | translate}}
          </div>
        </div>

        <div class="form-group no-mar-btm row pad-btm-10" [ngClass]="{'has-error': partInfoForm.get('dimensionLength').invalid && f.submitted }">
          <div class="col-md-6">
            {{'L' | translate}}
            <span class="required">*</span>
          </div>
          <div class="col-md-6">
            <input type="text" class="form-control dimension_input" formControlName="dimensionLength">
          </div>
          <errors [control]="partInfoForm.controls.dimensionLength"></errors>
          <div *ngIf="partInfoForm.get('dimensionLength').invalid && f.submitted" class="required-error">
            {{'FieldRequired' | translate}}
          </div>
        </div>
        <div class="form-group no-mar-btm row" [ngClass]="{'has-error':  partInfoForm.get('dimensionHeight').invalid && f.submitted}">
          <div class="col-md-6">
            {{'H' | translate}}
            <span class="required">*</span>
          </div>
          <div class="col-md-6">
            <input type="text" class="form-control dimension_input" formControlName="dimensionHeight">
          </div>
          <errors [control]="partInfoForm.controls.dimensionHeight"></errors>
          <div *ngIf="partInfoForm.get('dimensionHeight').invalid && f.submitted" class="required-error">
            {{'FieldRequired' | translate}}
          </div>
        </div>
      </div>
      <div class="col-md-6 pad-top-40 picture_part pad-lr-40 pad-btm-30">
        <div class="dta_title col-md-6 no-pad mar-btm-20">{{'PICOFPART' | translate}}</div>
        <!-- <div class="row img_upload pad-top-40 text-center">
          <div class="col-md-4 text-center">
            <button type="button" class="btn btn-dark upload_img" data-toggle="modal" data-target="#uploadImgModal">Upload File</button>
                <div class="upload_img_legend text-center pad-top-5">(Max upload of 5 images only)</div>
          </div>
          <div class="col-md-8 text-center">
              <button type="button" class="btn btn-dark upload_img" data-toggle="modal" data-target="#uploadImgModal">Add Another</button>
            </div>
        </div> -->

        <p-fileUpload #form id="newsfeed-upload" name="imageFiles[]" auto="true" mode="advanced" fileLimit="5"
          fileLimitMessage="Only 5 image" accept="image/*" maxFileSize="10000000" customUpload="true" (uploadHandler)="uploadPartImg($event, form)"
          [disabled]="disableSubmit || disableDelete" chooseLabel="{{'Choose' | translate}}"></p-fileUpload>
        <p class="text-danger" *ngIf="isDuplicationFilename"><b>{{'Duplicate' | translate}}</b></p>
        <div class="upload_img_legend text-left pad-top-5">{{'RECOMMENDED_TO_UPLOAD' | translate}} </div>
        <!-- <p-fileUpload name="demo[]" url="http://api-logbase.20.188.6.82.nip.io:80/partInfo/images/AutoNew89932_41_02" (onUpload)="onUpload($event)" multiple="multiple" accept="image/*" maxFileSize="1000000">
          </p-fileUpload> -->

        <div class="image_viewer pad-top-30">
          <table _ngcontent-c3="" class="table table-md">
            <thead _ngcontent-c3="" class="thead-light">
              <tr _ngcontent-c3="">
                <th _ngcontent-c3="" scope="col">{{'IMAGES' | translate}}</th>
              </tr>
            </thead>
            <tbody _ngcontent-c3="">
            </tbody>
          </table>

          <div class="img_brd_btm mar-top-30" *ngFor="let img of partImageDetails">
            <div class="row" *ngIf="img.imageUri">
              <div class="part_img_box">
                <span *ngIf="!img.imageUri" class="blinking">{{'Please wait, Uploading file(s) ...' | translate}}</span>
                <img src="{{getImgUri(img.imageUri)}}">
              </div>
              <div class="col-md-3 text-right">
                <button type="button" class="btn btn-dark" (click)="openImgDelCfm(img, imgdelModal)" [disabled]="disableSubmit || disableDelete">{{'DELETE'
                  | translate}}</button>
              </div>
            </div>
            <!-- <div class="part_img_box">
              <span *ngIf="!img.imageUri" class="blinking">{{'Please wait, Uploading file(s) ...' | translate}}</span>
              <img src="{{img.imageUri}}">
            </div> -->
          </div>
          <div class="text-center" *ngIf="partImageDetails?.length <= 0">
            {{'IMG_NOT_UPLOADED' | translate}}
          </div>
        </div>
      </div>
      <div class="col-md-4 pad-top-40 update_part pad-lr-30 pad-btm-30">

        <div class="form-group row">
          <label for="" class="col-sm-6 col-form-label">{{'DELIVERYPLANTNAME' | translate}}</label>
          <div class="col-sm-6">
            <input type="text" class="form-control" formControlName="plantName">
          </div>
        </div>

        <div class="form-group row">
          <label for="" class="col-sm-6 col-form-label">{{'DELIVERYTIMEWINDOW' | translate}}
            <span class="required">*</span>
          </label>
          <div class="col-sm-6">

            <input type="text" class="form-control" formControlName="deliveryTimeWindow">
          </div>
        </div>

        <div class="form-group row">
          <label for="" class="col-sm-6 col-form-label">{{'DELIVERYPOINT' | translate}}
            <span class="required">*</span>
          </label>
          <div class="col-sm-6">
            <input type="text" class="form-control" formControlName="deliveryPoint">
          </div>
        </div>

        <div class="form-group row" [ngClass]="{'has-error': (partInfoForm.get('lineNumber').touched || 
        partInfoForm.get('lineNumber').dirty) 
        && partInfoForm.get('lineNumber').invalid }">
          <label for="" class="col-sm-6 col-form-label">{{'Next_Process' | translate}}
            <span class="required">*</span>
          </label>
          <div class="col-sm-6">
            <input type="text" class="form-control" formControlName="lineNumber">
            <errors [control]="partInfoForm.controls.lineNumber"></errors>
          </div>
        </div>

        <div class="dta_title pad-top-10 pad-btm-20">{{'PARTHISTORY' | translate}}</div>
        <table class="table table-md">
          <thead _ngcontent-c3="" class="thead-light">
            <tr _ngcontent-c3="">
              <th _ngcontent-c3="" scope="col">{{'DATETIME' | translate}}</th>
              <th _ngcontent-c3="" scope="col">{{'STATUS' | translate}}</th>
              <th _ngcontent-c3="" scope="col">{{'UPDATEDBY' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let list of this.partData?.historyList">
              <td>{{list.packageIdStatusChangeDate | date:'yyyy-MM-dd HH:mm'}}</td>
              <td *ngIf="list.packageIdStatus == 'new'">New</td>
              <td *ngIf="list.packageIdStatus == 'inProgress'">In Progress</td>
              <td *ngIf="list.packageIdStatus == 'underReview'">Under Review</td>
              <td *ngIf="list.packageIdStatus == 'approved'">Approved</td>
              <td *ngIf="list.packageIdStatus == 'rejected'">Rejected</td>
              <td *ngIf="list.packageIdStatus == 'approvedAndClosed'">Approved &amp; Closed</td>
              <td *ngIf="list.packageIdStatus == 'rejectedAndClosed'">Rejected &amp; Closed</td>
              <td>{{list.updatedBy}}</td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>

    <div class="row pad-tb-30 top_dash_brd action_section">
      <div class="col-md-6 text-center">
        <button type="submit" class="btn btn-dark" (click)="savePartForm()" [disabled]="disableSubmit" id="partInfoSave">{{'SAVE'
          | translate}}</button>
      </div>
      <div class="col-md-6 text-left">
        <button type="button" class="btn btn-dark" (click)="saveNextPartInfo()" [disabled]="disableSubmit" id="partInfoNext">{{'NEXT'
          | translate}}</button>
      </div>

    </div>
  </section>
</form>

<!-- Upload Image Modal -->
<div class="modal fade" id="uploadImgModal" tabindex="-1" role="dialog" aria-labelledby="uploadImgModalLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="uploadImgModalLabel">{{'Upload Part Image' | translate}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row pad-btm-30">
          <div class="col-md-4">
            {{'Part Title' | translate}}
          </div>
          <div class="col-md-8">
            <input type="text" class="form-control" id="" placeholder="">
          </div>
        </div>
        <div class="row pad-btm-30">
          <div class="col-md-10">
            <input type="file" class="form-control-file" id="">
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-dark">Update</button>
        <button type="button" class="btn btn-dark-brd" data-dismiss="modal">{{'CANCEL' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<!-- Part Number History Modal -->

<ng-template #history let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Part Number History</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Page Under Construction ..</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="c('Close click')">Close</button>
  </div>
</ng-template>

<!-- Part Image deletion confirmation Modal -->

<ng-template #imgdelModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">{{'confirm_box' | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>{{'Delete_confirmation' | translate}}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn btn-dark" (click)="deletePartImg()">{{'Yes' | translate}}</button>
    <button type="button" class="btn btn-outline-dark" (click)="c('Close click')">{{'No' | translate}}</button>
  </div>
</ng-template>

<!-- Lookup Modal -->
<ng-template class="modal fade" #lookupModal let-c="close" let-d="dismiss">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="lookupModalLabel">{{'LOOKUP' | translate}}</h5>
      <button type="button" class="close" (click)="d('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="codeList mar-top-20">
        <p-table [value]="revisionList" selectionMode="single" [responsive]="true" [rows]="10" [paginator]="true" [pageLinks]="3"
          [rowsPerPageOptions]="[10,25,50,100]" [(selection)]="pkgselect">
          <!-- <p-column [style]="{'width':'40px'}" selectionMode="single"></p-column>
          <p-column field="partNumber" header="{{'PARTNUMBER' | translate}}" [sortable]="true" [filter]="true"
            filterPlaceholder="{{'Search Part No' | translate}}"></p-column>
          <p-column field="partName" header="{{'PARTNAME' | translate}}" [sortable]="true" [filter]="true"
            filterPlaceholder="{{'Search Part Name' | translate}}"></p-column>
          <p-column field="packageId" header="{{'PACKAGEID' | translate}}" [sortable]="true" [filter]="true"
            filterPlaceholder="{{'Search package ID' | translate}}"></p-column>
          <p-column field="deliveryPoint" header="{{'DELIVERYPOINT' | translate}}" [sortable]="true" [filter]="true"
            filterPlaceholder="{{'Search Delivery Point' | translate}}"></p-column>
          <p-column field="lineNumber" header="{{'Next_Process' | translate}}" [sortable]="true" [filter]="true"
            filterPlaceholder="{{'Search Next Process' | translate}}"></p-column>
          <p-column field="assignedDate" header="{{'ASSIGNEDDATE' | translate}}" [sortable]="true" [filter]="false"
            filterPlaceholder="Search Assigned Date">
            <ng-template let-col let-row="rowData" pTemplate="body">
              <span>{{row[col.field] | date: 'dd-MM-yyy'}}</span>
            </ng-template>
          </p-column>
          <p-column field="dueDate" header="{{'DUEDATE' | translate}}" [sortable]="true" [filter]="false"
            filterPlaceholder="Search Due Date">
            <ng-template let-col let-row="rowData" pTemplate="body">
              <span>{{row[col.field] | date: 'yyy-MM-dd'}}</span>
            </ng-template>
          </p-column> -->
          <ng-template pTemplate="header">
            <tr>
                <th style="width: 40px">
                 <!-- <p-tableHeaderCheckbox></p-tableHeaderCheckbox> -->
                </th>
                <th pSortableColumn="partNumber" style="width:20%">{{'PARTNUMBER' | translate}} <p-sortIcon field="partNumber"></p-sortIcon></th>
                <th pSortableColumn="partName" style="width:20%">{{'PARTNAME' | translate}} <p-sortIcon field="partName"></p-sortIcon></th>
                <th pSortableColumn="packageId" style="width:20%">{{'PACKAGEID' | translate}}<p-sortIcon field="packageId"></p-sortIcon></th>
                <th pSortableColumn="deliveryPoint" style="width:20%">{{'DELIVERYPOINT' | translate}} <p-sortIcon field="deliveryPoint"></p-sortIcon></th>
                <th pSortableColumn="lineNumber" style="width:20%">{{'Next_Process' | translate}} <p-sortIcon field="lineNumber"></p-sortIcon></th>
                <th pSortableColumn="assignedDate" style="width:20%">{{'ASSIGNEDDATE' | translate}} <p-sortIcon field="assignedDate"></p-sortIcon></th>
                <th pSortableColumn="dueDate" style="width:20%">{{'DUEDATE' | translate}} <p-sortIcon field="dueDate"></p-sortIcon></th>
            </tr>
            <tr>
              <th>
            </th>
              <th>
                <p-columnFilter type="text" field="partNumber"></p-columnFilter>
            </th>
            <th>
              <p-columnFilter type="text" field="partName"></p-columnFilter>
             </th>
             <th>
            <p-columnFilter type="text" field="packageId"></p-columnFilter>
            </th>
            <th>
               <p-columnFilter type="text" field="deliveryPoint"></p-columnFilter>
             </th>
            <th>
                <p-columnFilter type="text" field="lineNumber"></p-columnFilter>
           </th>
           <th>
           </th>
           <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-value>
            <tr [pSelectableRow]="value">
              <td>
                <p-tableCheckbox [value]="value"></p-tableCheckbox>
            </td>
                <td>{{value.partNumber}}</td>
                <td>{{value.partName}}</td>
                <td>{{value.packageId}}</td>
                <td>{{value.deliveryPoint}}</td>
                <td>{{value.lineNumber}}</td>
                <td>
                  <span>{{value.assignedDate | date: 'dd-MM-yyy'}}</span>
                </td>
                <td>
                  <span>{{value.dueDate | date: 'yyy-MM-dd'}}</span>
                </td>
            </tr>
        </ng-template>
        </p-table>
      </div>
    </div>
    <div class="modal-footer mar-top-10">
      <div class="row lookup_footer no-pad">
        <div class="col-md-6">
          <button type="button" class="btn btn-dark mar-rgt-10" (click)="showLookupData()">{{'SELECTCODE' |
            translate}}</button>
          <button type="button" class="btn btn-dark-brd" (click)="c('Cross click')">{{'CANCEL' | translate}}</button>
        </div>
        <div class="col-md-6 text-right">
        </div>
      </div>
    </div>
  </div>
</ng-template>